var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('ul',[_c('li',{staticClass:"tip"},[_vm._v("商品分类")]),_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.togo(item.id)}}},[_vm._v(_vm._s(item.title))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }